import React from 'react';
import { Popover as ElPopover } from 'element-react';
import cx from 'classnames';
import cs from './index.module.scss';

// element-react's runtime supports manual; its bundled typings omit it.
type PopoverProps = Omit<ElementReact.PopoverProps, 'trigger'> & {
  trigger?: 'click' | 'focus' | 'hover' | 'manual';
};

const PopoverWrapper: React.FC<PopoverProps> = ({
  children,
  className,
  trigger = 'hover',
  placement = 'bottom-start',
  visibleArrow = false,
  ...popoverProps
}) => (
  <ElPopover
    {...popoverProps}
    className={cx(cs.popoverWrapper, className)}
    trigger={trigger as ElementReact.PopoverProps['trigger']}
    visibleArrow={visibleArrow}
    placement={placement}
  >
    {children}
  </ElPopover>
);

export default PopoverWrapper;
